import NextLink from "next/link";

import { ButtonCookieSettings } from "#app/_ui/components/footers/ButtonCookieSettings";
import { Container } from "#ui/container";
import { Copyright, Footer, FooterNav } from "#ui/footer";
import { Logo } from "#ui/logo";

import { FooterLink } from "./FooterLink";
import { classNamesFooterLink } from "./footers-utils";

export function UnauthorizedFooter() {
  return (
    <Footer className="py-100px text-shade-80">
      <Container className="space-y-30px">
        <NextLink href="/" className="block w-fit">
          <Logo layout="mark-only" size="md" />
        </NextLink>
        <FooterNav>
          <FooterLink
            href="https://www.rwbaird.com/help/baird-terms-of-use/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Baird Terms of Use
          </FooterLink>{" "}
          <FooterLink
            href="https://www.rwbaird.com/help/privacy-notice/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </FooterLink>{" "}
          <FooterLink
            href="https://www.rwbaird.com/help/privacy-notice/#vertTab-5456"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </FooterLink>{" "}
          <ButtonCookieSettings className={classNamesFooterLink} />{" "}
          <FooterLink href="/tech-support">Contact &amp; FAQs</FooterLink>
        </FooterNav>
        <Copyright />
      </Container>
    </Footer>
  );
}
